/**
 * @license Highmaps JS v12.2.0 (2025-04-07)
 * @module highcharts/modules/heatmap
 * @requires highcharts
 *
 * (c) 2009-2025 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */
'use strict';
import Highcharts from '../../Core/Globals.js';
import './coloraxis.src.js';
import '../../Series/Heatmap/HeatmapSeries.js';
export default Highcharts;
